import { render } from "./servicesView.vue?vue&type=template&id=237d8ac4&scoped=true"
import script from "./servicesView.vue?vue&type=script&lang=js"
export * from "./servicesView.vue?vue&type=script&lang=js"

import "./servicesView.vue?vue&type=style&index=0&id=237d8ac4&scoped=true&lang=css"

import exportComponent from "/home/beatriz/Documents/GitHub/virtus_consult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237d8ac4"]])

export default __exports__